export default {
  data: [
    '',
    {
      id: 1,
      title: 'Нәдіров Тайман Асылбекұлы'
    },
    {
      id: 3,
      title: 'Нетжанова Шынар Акдуйсенова'
    },
    {
      id: 5,
      title: 'Куанышев Данияр Айбекұлы'
    },
    {
      id: 8,
      title: 'Жұмабай Жанар Жұмабайқызы'
    },
    {
      id: 9,
      title: 'Нурышев Ақтілеу Таңбайұлы'
    }
  ]
}
